/**
 * SsaiSettingsCtrl controller
 * Show all ssai settings
 */

import { SSAI_CONTENT_TYPES } from '../../app/core/constants'

// controller mixins
SsaiSettingsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * SsaiSettingsCtrl controller
 *
 * @class SsaiSettingsCtrl
 * @memberof mwApp/ssais
 * @see mwApp/ssais
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:SsaiSettingsCtrl
 */
/* @ngInject */

export default function SsaiSettingsCtrl ($scope, SsaiParameter, macroCategories, macrosCatalog, parameterTypes, contentType, contentTypeKey) {
  const vm = this
  vm.contentTypes = SSAI_CONTENT_TYPES
  vm.parameterTypes = parameterTypes
  vm.macrosTypesLength = Object.keys(parameterTypes).length + 1
  vm.contentTypeKey = contentTypeKey
  vm.macroCategories = macroCategories

  vm.getParameters = function (tableState) {
    if (tableState?.search?.predicateObject?.macroCategoryId) {
      tableState.search.predicateObject['macro-category-id'] = tableState.search.predicateObject.macroCategoryId
    } else {
      delete tableState.search.predicateObject?.['macro-category-id']
    }
    SsaiParameter.loadSmart(tableState, { contentType })
      .then(
        data => {
          vm.parameters = data.content
          vm.parameters.forEach(parameter => {
            SsaiParameter.findMacros(parameter, macrosCatalog)
          })
          vm.isFound = !!vm.parameters.length
          $scope.loading = false
        }
      )
  }

  vm.delete = function (parameter) {
    parameter._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
